import React from 'react';
import { CalendarClockIcon, CompassIcon, SparklesIcon, UserCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const points = [[CalendarClockIcon, 'Du verbringst deine Abende mit der Suche nach passendem Musikmaterial.'], [CompassIcon, 'Du bist unsicher, wie du die Themen sinnvoll aufeinander aufbaust.'], [SparklesIcon, 'Du wünschst dir Aktivitäten, die die ganze Klasse begeistern.'], [UserCheckIcon, 'Du unterrichtest Musik fachfremd und brauchst einen roten Faden.']] as const;
export function PainPointsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-116" data-mp="3ffslmqlyyb1o">
      <Reveal className="mx-auto max-w-4xl text-center" data-id="element-117" data-mp="3fhdfee0glpyh">
        <h2 className="text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-118" data-mp="3ahr1s3gpy7p5">
          <span className="text-brand-orange" aria-hidden="true" data-id="element-119" data-mp="3offprk631uyf">
            ✧
          </span>{' '}
          Erkennst du dich in diesen Situationen wieder?
        </h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-120" data-mp="surpwmtchtz9">
          {points.map(([PointIcon, text]) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-line bg-brand-main p-6 text-left shadow-sm" data-id="element-121" data-mp="ww3dynwkm75c">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange" data-id="element-122" data-mp="16uj7exj2lsi0">
                <PointIcon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="1bskqvjkertu0" />
              </span>
              <span className="text-sm font-semibold leading-snug" data-id="element-124" data-mp="1fupkwjerqsh6">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-script text-2xl italic text-brand-orange" data-id="element-125" data-mp="1kn8ul5ac53gp">
          Und du verdienst so viel mehr als das.
        </p>
      </Reveal>
    </section>;
}